import React, { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppThemeProvider } from './theme';
import { LanguageProvider } from './utils/LanguageContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { EstimateProvider } from './contexts/EstimateContext';
import AppShell from './components/layout/AppShell';
import LandingPage from './components/landing/LandingPage';
import AuthPage from './components/auth/AuthPage';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import HomeDashboard from './components/home/HomeDashboard';
import EstimateStartPage from './components/estimate/EstimateStartPage';
import QuickEstimatePage from './components/estimate/QuickEstimatePage';
import DetailedEstimatePage from './components/estimate/DetailedEstimatePage';
import EstimateResultPage from './components/estimate/EstimateResultPage';
import CalculatorsPage from './components/calculators/CalculatorsPage';
import CalculatorPage from './components/calculators/CalculatorPage';
import ProjectsPage from './components/projects/ProjectsPage';
import ProjectDetailPage from './components/projects/ProjectDetailPage';
import { AccountPage } from './components/account';
import PaymentResultPage from './components/account/PaymentResultPage';

function App() {
  // Remember a referral code from invite links (/auth?ref=CODE) so it can be applied at sign-up.
  // Other pages use ?ref= for other things (e.g. /payment/success?ref=RK… is a payment reference).
  useEffect(() => {
    const { pathname, search } = window.location;
    const ref = new URLSearchParams(search).get('ref');
    if (ref && (pathname === '/' || pathname.startsWith('/auth'))) {
      localStorage.setItem('rumahkira_referral_code', ref.toUpperCase());
    }
  }, []);

  return (
    <AppThemeProvider>
      <LanguageProvider>
        <SubscriptionProvider>
          <EstimateProvider>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/auth/forgot-password" element={<ForgotPassword />} />
              <Route path="/auth/reset-password" element={<ResetPassword />} />
              <Route path="/payment/success" element={<PaymentResultPage />} />

              <Route path="/app" element={<AppShell />}>
                <Route index element={<HomeDashboard />} />
                <Route path="estimate" element={<EstimateStartPage />} />
                <Route path="estimate/quick" element={<QuickEstimatePage />} />
                <Route path="estimate/detailed" element={<DetailedEstimatePage />} />
                <Route path="estimate/result" element={<EstimateResultPage />} />
                <Route path="calculators" element={<CalculatorsPage />} />
                <Route path="calculators/:materialId" element={<CalculatorPage />} />
                <Route path="projects" element={<ProjectsPage />} />
                <Route path="projects/:projectId" element={<ProjectDetailPage />} />
                <Route path="account" element={<AccountPage />} />
                <Route path="settings" element={<Navigate to="/app/account" replace />} />
                <Route path="*" element={<Navigate to="/app" replace />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </EstimateProvider>
        </SubscriptionProvider>
      </LanguageProvider>
    </AppThemeProvider>
  );
}

export default App;
